import { Alert, Card, Skeleton } from "antd";

import { useState } from "react";

import HrText from "components/HrText/HrText";
import "./FattureUtente.css";
import IFattureUtente from "pages/AreaRiservata/FattureUtente/IFattureUtente";
import { FaFileDownload } from "react-icons/fa";
import _ from "lodash";
import { CustomButton } from "core/interfaces/components";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { Enhanced } from "utils/ReactUtils";
import  PagamentiRep  from "core/data/PagamentiRepository";

const FattureUtente: React.FC<IFattureUtente> = ({ fatture, t, i18n }) => {
	const [loading] = useState<boolean>(false);

	const onScaricaFattura = (idEcDoc: number) => {
		PagamentiRep.getFattura(idEcDoc, i18n.language);
	};

	return (
		<>
			{loading ? (
				<Skeleton active />
			) : (
				<>
					<div id="fattureUtente">
						{fatture ? (
							<>
								<HrText text={t("fatture.title")} />
								{_.sortBy(fatture, "IdPreventivo").map((res, index) => {
									return (
										<Card key={index} className="fatture-card">
											<span className="fatture-card-titles">
												{t("reservedArea.FattureUtente.cardTitle").format(
													res.DataFattura.toFormattedDateString("DD/MM/YYYY"),
													res.Nominativo,
													res.NumDocEsteso
												)}
												{res.CodPai !== undefined && (
													<>
														<br />
														<span className="fatture-card-titles preventivo">
															{t("reservedArea.FattureUtente.cardTitle.Preventivo").format(
																res.CodPai,
																res.DataPreventivo!.toFormattedDateString("DD/MM/YYYY")
															)}
														</span>
													</>
												)}
											</span>
											<div className="fatture-card-detils">
												{res.DettagliFattura.map((dett, ix) => {
													return (
														<div key={index + "/" + ix.toString()}>
															<span className="fatture-card-item">
																<div className="activity"> {dett.EcDocDett} </div>
																{/* {dett.Qta && <div className="activity"> {t("reservedArea.FattureUtente.qta") + " " + dett.Qta} </div>} */}
															</span>
														</div>
													);
												})}
												<div className="fatture-card-totals">
													{res.TotPagato !== res.TotAPagare && (
														<>
															<hr style={{ width: "100%" }} />

															<div className="fatture-card-totals-detail">
																<span>{t("reservedArea.FattureUtente.importoPagato")}</span>
																<span>
																	{res.TotPagato.toLocaleString(
																		undefined, // leave undefined to use the visitor's browser
																		// locale or a string like 'en-US' to override it.
																		{ style: "currency", currency: "EUR" }
																	)}
																</span>
															</div>
															<div className="fatture-card-totals-detail">
																<span>{t("reservedArea.FattureUtente.importoResiduo")}</span>
																<span>
																	{(res.TotAPagare - res.TotPagato).toLocaleString(
																		undefined, // leave undefined to use the visitor's browser
																		// locale or a string like 'en-US' to override it.
																		{ style: "currency", currency: "EUR" }
																	)}
																</span>
															</div>
														</>
													)}
													<div className="fatture-card-totals-detail">
														<span>{t("reservedArea.FattureUtente.importo")}</span>
														<span>
															{res.TotAPagare.toLocaleString(
																undefined, // leave undefined to use the visitor's browser
																// locale or a string like 'en-US' to override it.
																{ style: "currency", currency: "EUR" }
															)}
														</span>
													</div>
												</div>
											</div>
											<div className="fatture-card-pay">
												<div>
													<CustomButton
														buttonType={CustomButtonType.positive}
														text={t("reservedArea.fatture.ScaricaFattura")}
														icon={<FaFileDownload /> /*FaFileInvoiceDollar*/}
														OnClick={() => onScaricaFattura(res.IdEcDoc!)}
														download
													></CustomButton>
												</div>
											</div>
										</Card>
									);
								})}
							</>
						) : (
							<Alert message={t("errorMessages.base")} type="error" showIcon banner />
						)}
					</div>
				</>
			)}
		</>
	);
};

export default Enhanced(FattureUtente,{componentNamespace:"FattureUtente"});
